import { Component, ChangeDetectionStrategy } from "@angular/core";
import { Icon } from "../utils/icon/icon";

@Component({
  selector: "loader",
  imports: [Icon],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: "./loader.html",
})
export class Loader {}
